module.exports = __webpack_public_path__ + "assets/img/ic-right-arrow1f20f681.svg";